<template>
    <div class="login-bg">
        <div class="login-container">
            <img src="/static/img/login_img.png" alt="">
            <div class="login-box">
                <div v-if="handleType == 0 || handleType == 1">
                    <div class="login-header">
                        <div class="name-pwd" :class="handleType==0?'active':''" @click="changeHandleType(0)">用户登录</div>
                        <div class="register" :class="handleType==1?'active':''" @click="changeHandleType(1)">用户注册</div>
                    </div>
                    <div v-if="handleType == 0">
                        <div class="inputs">
                            <div class="input-container">
                                <input class="input" type="text" v-model="phone" maxlength="11" placeholder="请输入手机号码" />
                                <div class="close-btn iconfont icon-guanbi" @click="cleanPhone" v-if="phone"></div>
                            </div>
                            <div class="input-container">
                                <input class="input pwd" :type="showPwd?'text':'password'" v-model="pwd" maxlength="32"
                                    placeholder="请输入密码" />
                                <div class="eye iconfont" :class="showPwd?'icon-kai':'icon-guan'" @click="toggleEye">
                                </div>
                            </div>
                        </div>
                        <div class="handle-btn" @click="login">登 录</div>
                        <div class="ex">
                            <div class="error-info">{{errMsg}}</div>
                            <div class="forget" @click="changeHandleType(2)">忘记密码</div>
                        </div>
                    </div>
                    <div v-else-if="handleType==1">
                        <div class="inputs">
                            <div class="input-container">
                                <input class="input" type="text" v-model="username" maxlength="20"
                                    placeholder="请输入用户名称" />
                                <div class="close-btn iconfont icon-guanbi" @click="cleanUsername" v-if="username">
                                </div>
                            </div>
                            <div class="input-container">
                                <input class="input" type="text" v-model="phone" maxlength="11" placeholder="请输入手机号码" />
                                <div class="close-btn iconfont icon-guanbi" @click="cleanPhone" v-if="phone"></div>
                            </div>
                            <div class="input-container">
                                <input class="input pwd" :type="showPwd?'text':'password'" v-model="pwd" maxlength="32"
                                    placeholder="请输入密码（长度>=6）" />
                                <div class="eye iconfont" :class="showPwd?'icon-kai':'icon-guan'" @click="toggleEye">
                                </div>
                            </div>
                            <div class="input-container">
                                <input class="input pwd" type="text" v-model="captchaCode" placeholder="请输入验证码" />
                                <div class="captcha-code" @click="getCaptchaCode">
                                    <div v-if="timeLeft == 0">获取验证码</div>
                                    <div v-else>还剩 {{timeLeft}} 秒</div>
                                </div>
                            </div>
                        </div>
                        <div class="handle-btn" @click="register">注 册</div>
                        <div class="ex">
                            <div class="error-info">{{errMsg}}</div>
                            <div class="forget" @click="changeHandleType(2)">忘记密码</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="login-header">
                        <div class="active">找回密码</div>
                    </div>
                    <div>
                        <div class="inputs">
                            <div class="input-container">
                                <input class="input" type="text" v-model="phone" maxlength="11" placeholder="请输入手机号码" />
                                <div class="close-btn iconfont icon-guanbi" @click="cleanPhone" v-if="phone"></div>
                            </div>
                            <div class="input-container">
                                <input class="input pwd" :type="showPwd?'text':'password'" v-model="pwd" maxlength="32"
                                    placeholder="请输入密码" />
                                <div class="eye iconfont" :class="showPwd?'icon-kai':'icon-guan'" @click="toggleEye">
                                </div>
                            </div>
                            <div class="input-container">
                                <input class="input pwd" type="text" v-model="captchaCode" placeholder="请输入验证码" />
                                <div class="captcha-code" @click="getCaptchaCode">
                                    <div v-if="timeLeft == 0">获取验证码</div>
                                    <div v-else>还剩 {{timeLeft}} 秒</div>
                                </div>
                            </div>
                        </div>
                        <div class="handle-btn" @click="changePwd">修 改</div>
                        <div class="ex">
                            <div class="error-info">{{errMsg}}</div>
                            <div class="forget" @click="changeHandleType(0)">用户登录</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            screenHeight: 0,
            handleType: 0,
            username: "",
            phone: "",
            pwd: "",
            showPwd: false,
            captchaCode: "",
            timeLeft: 0,
            timer: null,
            errMsg: ""
        }
    },
    mounted() {
        this.screenHeight = document.body.clientHeight;
    },
    methods: {
        changeHandleType(type) {
            if (this.handleType != type) {
                this.handleType = type;
                this.username = "";
                this.phone = "";
                this.pwd = "";
                this.showPwd = false;
                this.captchaCode = "";
                this.errMsg = "";
            }
        },
        cleanUsername() {
            this.username = "";
        },
        cleanPhone() {
            this.phone = "";
        },
        cleanPwd() {
            this.pwd = "";
        },
        toggleEye() {
            this.showPwd = !this.showPwd;
        },
        getCaptchaCode() {
            if (this.timeLeft > 0) {
                return;
            }
            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            let reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            this.errMsg = "";
            this.timeLeft = 60;
            this.timer = setInterval(() => {
                this.timeLeft--;
                if (this.timeLeft == 0) {
                    clearInterval(this.timer);
                }
            }, 1000);
            // 发送验证码
            this.axios.post(this.$apiUrl + "/developcommon/getCaptcha", {
                phone: this.phone
            }).then(res => {
                if (res.data.code != 200) {
                    this.$showErrorMsg(res.data.msg);
                } else {
                    this.$showSuccessMsg("验证码已发送请注意查收");
                }
            });
        },
        register() {
            if (!this.username) {
                this.$showErrorMsg("请输入用户名");
                return;
            }
            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            let reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            if (!this.pwd) {
                this.$showErrorMsg("请输入密码");
                return;
            }
            if (this.pwd.length < 6) {
                this.$showErrorMsg("密码长度必须>=6");
                return;
            }
            if (!this.captchaCode) {
                this.$showErrorMsg("请输入验证码");
                return;
            }
            if (this.captchaCode.length != 6) {
                this.$showErrorMsg("请输入正确的验证码");
                return;
            }
            this.errMsg = "";
            // 注册开发者
            this.axios.post(this.$apiUrl + "/developcommon/register", {
                name: this.username,
                mobile: this.phone,
                password: this.pwd,
                captchaCode: this.captchaCode
            }).then(res => {
                if (res.data.code != 200) {
                    this.$showErrorMsg(res.data.msg);
                } else {
                    this.$showSuccessMsg("恭喜您注册成功请登录~");
                    this.handleType = 0;
                    this.username = "";
                    this.showPwd = false;
                    this.captchaCode = "";
                    this.errMsg = "";
                }
            });
        },
        changePwd() {
            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            let reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            if (!this.pwd) {
                this.$showErrorMsg("请输入密码");
                return;
            }
            if (this.pwd.length < 6) {
                this.$showErrorMsg("密码长度必须>=6");
                return;
            }
            if (!this.captchaCode) {
                this.$showErrorMsg("请输入验证码");
                return;
            }
            if (this.captchaCode.length != 6) {
                this.$showErrorMsg("请输入正确的验证码");
                return;
            }
            this.errMsg = "";
            // 修改密码
            this.axios.put(this.$apiUrl + "/developcommon/changPwd", {
                mobile: this.phone,
                password: this.pwd,
                captchaCode: this.captchaCode
            }).then(res => {
                if (res.data.code != 200) {
                    this.$showErrorMsg(res.data.msg);
                } else {
                    this.$showSuccessMsg("恭喜您密码修改成功请登录~");
                    this.handleType = 0;
                    this.username = "";
                    this.showPwd = false;
                    this.captchaCode = "";
                    this.errMsg = "";
                }
            });
        },
        login() {
            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            let reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            if (!this.pwd) {
                this.$showErrorMsg("请输入密码");
                return;
            }
            if (this.pwd.length < 6) {
                this.$showErrorMsg("密码长度必须>=6");
                return;
            }
            this.errMsg = "";
            // 登录
            this.axios.get(this.$apiUrl + "/developcommon/login", {
                params: {
                    phone: this.phone,
                    password: this.pwd
                }
            }).then(res => {
                if (res.data.code != 200) {
                    this.$showErrorMsg(res.data.msg);
                } else {
                    let result = res.data.data;
                    let developer = result.developer;
                    let appSecret = developer.appSecret;
                    let appSecretDot = appSecret.substr(0, 10) + "**********" + appSecret.substr(20);
                    developer.appSecretDot = appSecretDot;
                    sessionStorage.setItem("loginInfo", JSON.stringify(result));
                    this.$showSuccessMsg("登录成功");
                    this.pwd = "";
                    this.errMsg = "";
                    this.$router.push("/backend/index");
                }
            });
        }
    }
}
</script>


<style scoped>
.login-bg {
    background: url("/static/img/bg_login.jpg") center top no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    min-width: 1280px;
}

.login-container {
    display: flex;
    align-items: center;
    justify-content: right;
    margin: 0 auto;
    width: 1280px;
    height: 100vh;
}

.login-container img {
    width: 560px;
    margin: 120px;
}

.login-box {
    background-color: #fff;
    padding: 30px 50px;
    width: 450px;
    margin-left: 60px;
}

.login-header {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.name-pwd {
    margin-right: 60px;
    padding-bottom: 5px;
    cursor: pointer;
}

.register {
    padding-bottom: 5px;
    cursor: pointer;
}

.active {
    color: #FF6700;
    border-bottom: 2px solid #FF6700;
}

.inputs {
    margin-top: 30px;
}

.input-container {
    display: flex;
    border-bottom: 1px solid #d7d8d9;
    align-items: center;
    width: 320px;
}

.input-container+.input-container {
    margin-top: 15px;
}

.close-btn {
    font-size: 12px;
    cursor: pointer;
}

.eye {
    font-size: 16px;
    cursor: pointer;
    margin-left: 10px;
}

.captcha-code {
    background-color: #ccc;
    padding: 5px 15px;
    cursor: pointer;
}

.input {
    flex: 1;
    font-size: 16px;
    outline: 0px;
    padding: 10px;
    height: 40px;
    line-height: 40px;
    position: relative;
}

.handle-btn {
    margin-top: 30px;
    background-color: #FF6700;
    color: #fff;
    padding: 15px;
    cursor: pointer;
    user-select: none;
}

.ex {
    margin-top: 10px;
    display: flex;
}

.forget {
    text-align: right;
    cursor: pointer;
    color: #999;
    font-size: 14px;
}

.error-info {
    flex: 1;
    text-align: left;
    font-size: 14px;
    color: red;
}
</style>


// WEBPACK FOOTER //
// login.vue?1644456c